import { render, staticRenderFns } from "./BenefitButton.vue?vue&type=template&id=c1b2f28e"
import script from "./BenefitButton.vue?vue&type=script&lang=js"
export * from "./BenefitButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports